
const { document } = require('window');

const $ = require('jquery');

require('bootstrap');
require('./collapse');


$(document).on('click.bs.faq.data-api', '[data-apply="faq"] > dt', function (e) {
	const $this = $(this);

	if ($this.attr('data-toggle')) {
		return;
	}
	e.stopPropagation();

	$this.attr({
		'data-toggle': 'collapse',
		'data-target': '$next',
	});

	$this.trigger('click.bs.collapse.data-api');
});

